<template>
  <div>
    <section class="EOPPSection">
      <tip :info="info" />

      <div class="EOPPBody">
        <LateralMenu />

        <div class="EOPPContent">
          <MainInfo :oe="oe">
            <div class="botao" @click="activemodalmaininfo">
              <b-icon icon="pencil-alt" size="is-large"></b-icon>
            </div>
          </MainInfo>

          <Leaders>
            <div
              class="botao"
              style="margin-top: 0"
              @click="formLeadersActive = true"
            >
              <b-icon icon="pencil-alt" size="is-large"></b-icon>
            </div>
          </Leaders>

          <Members :oe="oe">
            <div
              class="botao"
              style="margin-top: 0"
              @click="formTeamMembersActive = true"
            >
              <b-icon icon="pencil-alt" size="is-large"></b-icon>
            </div>
          </Members>

          <Projects :oe="oe" v-if="oe.hasProjects">
            <div
              class="botao botao2"
              style="top: 0"
              @click="formActingActive = true"
            >
              <b-icon icon="pencil-alt" size="is-large"></b-icon>
            </div>
          </Projects>

          <Events :oe="oe" v-if="oe.hasEvents">
            <div
              class="botao botao2"
              style="top: 0"
              @click="formActingActive = true"
            >
              <b-icon icon="pencil-alt" size="is-large"></b-icon>
            </div>
          </Events>

          <recommendations />
        </div>
      </div>

      <b-modal :active="formMainInfoActive" :width="800" :can-cancel="false">
        <b-button @click="formMainInfoActive = false" class="closeModal">
          <b-icon icon="times" size="is-small"></b-icon>
        </b-button>

        <FormMainInfo :oe="oe" />
      </b-modal>

      <b-modal :active="formLeadersActive" :width="800" :can-cancel="false">
        <b-button @click="formLeadersActive = false" class="closeModal">
          <b-icon icon="times" size="is-small"></b-icon>
        </b-button>
        <FormLeaders :oe="oe" />
      </b-modal>

      <b-modal :active="formTeamMembersActive" :width="800" :can-cancel="false">
        <b-button @click="formTeamMembersActive = false" class="closeModal">
          <b-icon icon="times" size="is-small"></b-icon>
        </b-button>
        <FormTeamMembers :oe="oe" />
      </b-modal>

      <b-modal :active="formActingActive" :width="800" :can-cancel="false">
        <b-button @click="formActingActive = false" class="closeModal">
          <b-icon icon="times" size="is-small"></b-icon>
        </b-button>
        <FormActing :oe="oe" />
      </b-modal>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { commom } from "../../mixins/commom";
import tip from "./commom/Tip2";
import LateralMenu from "../lateral-menu/LateralMenu";
import MainInfo from "./edit-organization/MainInfo";
import Leaders from "./edit-organization/Leaders";
import Members from "./edit-organization/Members";
import Projects from "./edit-organization/Projects";
import Events from "./edit-organization/Events";
import FormMainInfo from "./edit-organization/FormMainInfo";
import FormLeaders from "./edit-organization/FormLeaders";
import FormTeamMembers from "./edit-organization/FormTeamMembers";
import FormActing from "./edit-organization/FormActing";
import recommendations from "./commom/Recommendation";

export default {
  name: "EditOrganizationProfilePanel",

  mixins: [commom],

  components: {
    tip,
    LateralMenu,
    MainInfo,
    Leaders,
    Members,
    Projects,
    Events,
    FormMainInfo,
    FormLeaders,
    FormTeamMembers,
    FormActing,
    recommendations
  },

  data() {
    return {
      isChangeLeaderModalActive: false,
      isLoading: false,
      organizationLeaderEmail: "",
      showOrganizationEmailInput: false,
      oe: {},

      oeHasFanpage: false,
      oeHasInsta: false,
      oeHasLinkedin: false,
      formMainInfoActive: false,
      formLeadersActive: false,
      formTeamMembersActive: false,
      formActingActive: false,
      info: {
        infoBorder: true,
        buttonText: "DICA",
        descriptionText:
          "Mantenha o Perfil da sua OE sempre atualizado e aumente as chances de serem convidados a participar de Parcerias Exclusivas com as Empresas Mentoras."
      }
    };
  },

  computed: {
    ...mapGetters(["organization"])
  },

  methods: {
    addCourseEntry() {
      this.oe.membersPerCourse.push({
        course: "",
        quantity: ""
      });
    },

    removeCourseEntry(index) {
      if (this.oe.membersPerCourse.length > 1) {
        this.oe.membersPerCourse.splice(index, 1);
      }
    },

    addContact() {
      this.oe.otherContacts.push({
        name: "",
        email: ""
      });
    },

    removeContact(index) {
      if (this.oe.otherContacts.length > 2) {
        this.oe.otherContacts.splice(index, 1);
      }
    },

    changeLeader(organizationLeaderEmail) {
      this.organizationLeaderEmail = organizationLeaderEmail;
      this.isChangeLeaderModalActive = !this.isChangeLeaderModalActive;
    },

    updateOrganization() {
      this.isLoading = true;
      this.$store
        .dispatch("updateOrganization", {
          oe: this.oe
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.showOrganizationEmailInput = false;
            this.$buefy.dialog.alert({
              title: "Sucesso!",
              message: "O perfil da OE foi atualizado ;)",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa"
            });
            if (this.oe.fanpage) {
              this.oeHasFanpage = true;
              if (this.oe.fanpage.indexOf("https") === -1) {
                this.oe.fanpage = "https://www.facebook.com/" + this.oe.fanpage;
              }
            }
            if (this.oe.insta) {
              this.oeHasInsta = true;
              if (this.oe.insta.indexOf("https") === -1) {
                this.oe.insta = "https://www.instagram.com/" + this.oe.insta;
              }
            }
            if (this.oe.linkedin) {
              this.oeHasLinkedin = true;
              if (this.oe.linkedin.indexOf("https") === -1) {
                this.oe.linkedin =
                  "https://www.linkedin.com/company/" + this.oe.linkedin;
              }
            }
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    activemodalmaininfo() {
      this.formMainInfoActive = true;
    }
  },

  mounted() {
    this.oe = JSON.parse(JSON.stringify(this.organization));
    if (!this.oe.organizationEmail || this.oe.organizationEmail === "") {
      this.showOrganizationEmailInput = true;
    }
    if (this.oe.membersPerCourse.length === 0) {
      this.oe.membersPerCourse.push({
        course: "",
        quantity: ""
      });
    }
    if (this.oe.otherContacts.length === 0) {
      this.oe.otherContacts.push({
        name: "",
        email: ""
      });
    }
    if (this.oe.fanpage) this.oeHasFanpage = true;
    if (this.oe.insta) this.oeHasInsta = true;
    if (this.oe.linkedin) this.oeHasLinkedin = true;

    this.oe.recommendationName = "";
    this.oe.recommendationContact = "";
    this.oe.recommendationInstagram = "";
  }
};
</script>

<style scoped>
.EOPPSection {
  padding-top: 5rem;
  padding-bottom: 1rem;
  max-width: 80rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
  background-color: #e9e9e9;
}
.EOPPBody {
  display: grid;
  grid-template-columns: auto auto;
  gap: 0.5rem;
}
.LateralMenu {
  background-color: #e9e9e9;
}
.EOPPContent {
  padding-top: 0.7rem;
}
.EOPPBlock {
  border: solid 0.5px rgb(175, 175, 175);
  border-radius: 0.5rem;
  background-color: white;
}
.botao {
  width: 3.5rem;
  height: 3.5rem;
  background-color: white;
  border: solid 0.5px rgb(175, 175, 175);
  border-radius: 100%;
  margin-top: 5rem;
  margin-left: auto;
  margin-right: 2rem;
}
.botao:hover,
.botao2:hover {
  cursor: pointer;
  transform: scale(1.1);
  transition: ease-in-out 0.1s;
}
.botao .icon {
  color: black;
  display: block;
  margin-left: 0.6rem;
  margin-top: 0.6rem;
}
.botao2 {
  position: absolute;
  right: 1rem;
  margin-right: 1rem;
  margin-top: 1rem;
}
.closeModal {
  border: transparent;
  right: 0.5rem;
  display: block;
  position: absolute;
}

@media (max-width: 1023px) {
  .EOPPBody {
    display: block;
  }
}
@media (max-width: 700px) {
  .representativeTip {
    display: block;
    margin-top: 0;
  }
  /* .EOPPSection{
    padding-top: 8rem;
  } */
}
@media (max-width: 500px) {
  .botao {
    margin-right: 1rem;
    margin-top: 2rem;
  }
}
</style>
